import { keyIssueSetEditMode } from "../../../../actions/key-issue-actions"

import buildViewFormActionButtonsWidgetContainer from "../../../common/build-view-form-action-buttons-widget-container"

export default buildViewFormActionButtonsWidgetContainer(
    keyIssueSetEditMode,
    "keyIssues"
)
